import client from "./clients/portalClient";
import calculationClient from "./clients/calculationClient";

const getProjectTerms = () => client.get(`/projects_terms`); // alle facturen over datum + deze week over datum

const getAllProjects = (cat) => client.get(`/projects?data=${cat}`);
const getProject = (id) => client.get(`/projects/${id}`);
const closeProject = (id) => client.post(`/projects/${id}/close`);
const closeKingProject = (id) => client.post(`/projects/${id}/king`);
const getProjectCalculations = (id) => calculationClient.get(`/get/project/${id}`);

const getProjectBookingDetail = (id, cat) => client.get(`/projects/${id}/booking_detail?article=${cat}`);

const getProjectHistory = (id) => client.get(`/projects/${id}/history`);
const getProjectMessages = (id) => client.get(`/projects/${id}/comments`);
const postProjectMessages = (id, data) => client.post(`/projects/${id}/comments`, data);
const deleteProjectMessages = (id, tId) => client.delete(`/projects/${id}/comments/${tId}`);

const getProjectTasks = (id) => client.get(`/projects/${id}/tasks`);
const postProjectTasks = (id, data) => client.post(`/projects/${id}/tasks`, data);
const editProjectTasks = (id, tId, data) => client.put(`/projects/${id}/tasks/${tId}`, data);
const deleteProjectTasks = (id, tId) => client.delete(`/projects/${id}/tasks/${tId}`);

const getTemplates= (id, cat) => client.get(`/projects/${id}/template?template=${cat}`)

const getProjectStructure = (id) => client.get(`/projects/${id}/structure`);

const editProjectReassessment = (id,data) => client.put(`/projects/${id}/re_estimate`, data);

const projectsApi = {
    getAllProjects,
    getProjectTerms,
    getProject,
    closeProject,
    closeKingProject,
    getProjectCalculations,
    getProjectBookingDetail,

    getProjectHistory,
    getProjectMessages,
    postProjectMessages,
    deleteProjectMessages,

    getProjectTasks,
    postProjectTasks,
    editProjectTasks,
    deleteProjectTasks,

    getProjectStructure,
    getTemplates,

    editProjectReassessment,
};

export default projectsApi;
